import ConfirmSubscriptionComponent from "../NonMVPComponents/ConfirmSubscriptionComponent";

const ConfirmSubscription = () => {
  return (
    <div>
      <ConfirmSubscriptionComponent />
    </div>
  );
};

export default ConfirmSubscription;
